<template>
    <div>
        <div v-if="!readyToLoad" class="text-center py-12 my-12" style="width: 100%">
            <v-progress-circular
                indeterminate 
                color="error darken-3" 
                class="my-12 py-12" 
                size="100" 
                width="8">
            </v-progress-circular>
        </div>
        <div v-else>
            <v-snackbar
                v-model="notify_user"
                :timeout="notify_user_duration"
                centered
                top
                elevation="20"
                :color="notify_user_color"
                class="pa-6 pt-0">
                <div class="center_snackbar_message" :class="notify_user_text_color" v-html="notify_user_message"></div>
            </v-snackbar>

            <v-dialog 
                v-model="disableDialog" 
                width="35%"
                elevation="8"
                persistent>
                <v-card>
                    <v-card-title class="headline primary darken-3 white--text">
                        <span class="mr-3">Confirm:</span> 
                        <span>{{ disableArgs.archive_action == 'unarchive' ? 'Unarchive Project' : disableArgs.archive_action == 'archive' ? 'Archive Project' : 'Delete Project Forever' }}</span>
                    </v-card-title>
            
                    <v-card-text class="mt-3">
                        <p v-if="disableArgs.archive_action == 'remove'">
                            By clicking the confirm button below you are affirming that you want to delete this project, which has no data associated with it, forever.
                        </p>
                        <p v-else>
                            By clicking the confirm button below you are affirming that you want to  {{ disableArgs.archive_action }} this project. 
                            <span v-if="disableArgs.archive_action == 'archive'">The client will no longer see this project on thier dashboard.</span>
                        </p>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn 
                            class="mr-3" 
                            outlined 
                            color="primary darken-3"
                            @click="disableDialog = false">
                            Cancel
                        </v-btn>
                        <v-btn 
                            class="white--text" 
                            color="primary darken-3"
                            @click="disableArchive(disableArgs)">
                            Confirm
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog> 

            <v-dialog 
                v-model="profileDialog" 
                transition="dialog-bottom-transition"
                max-width="83%"
                scrollable>
                <v-card>
                    <v-card-title class="info pewter--text d-flex justify-space-between">
                        <div class="justify-start mr-12">{{ user_data.full_name }}</div>
                        <div class="d-flex flex-grow-1">
                            <div class="justify-start mr-6">{{ user_data.user_email }}</div>
                            <v-divider v-if="user_data.phone" vertical class="pewter"></v-divider>
                            <div class="justify-center mx-6">{{ user_data.phone }}</div>
                            <v-divider v-if="user_data.city || user_data.state" vertical class="pewter"></v-divider>
                            <div class="justify-end ml-6">{{ user_data.city }}{{ user_data.city && user_data.state ? ', ': ' ' }}{{ user_data.state }}</div>
                        </div>
                        <v-spacer></v-spacer>
                        <div class="justify-end">
                            <v-btn 
                                icon 
                                dark 
                                class="ml-3"
                                @click="profileDialog = false">
                                <v-icon color="pewter">mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <ModuleQuestionnaire 
                            :user_id="user_data.user_id"
                            :is_secondary="user_data.is_secondary"
                            :module_key="moduleKey"
                            :module_id="moduleId"
                            :project_id="projectId"
                        />
                    </v-card-text>
                    <v-card-actions class="info">
                        <v-spacer></v-spacer>
                        <!-- <v-btn
                            outlined
                            color="pewter"
                            class="mr-3"
                            @click="buyerQuestionnaire_dialog = false">
                            close
                        </v-btn> -->
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog 
                v-model="deliverableDialog" 
                transition="dialog-bottom-transition"
                width="50%">
                <v-card>
                    <v-card-text>
                        <UploadDeliverables 
                            :projectData="projectDeliverables"
                            :moduleKey="moduleKey"
                            :projectId="projectId"
                            :userId="project_details.user_id"
                            :isDeliverable="true"
                            :revisionDocCount="3"
                            @closeUploadDeliverables="closeUploadDeliverables"
                            @pullProjectDelivs="pullProjectDelivs"
                            @pullActivityLogs="pullActivityLogs"
                        />
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-dialog 
                v-model="titleDialog" 
                transition="dialog-bottom-transition"
                width="50%">
                <v-card>
                    <v-card-title class="primary darken-2 white--text">Add an internal title for this project.</v-card-title>
                    <v-card-text>
                        <v-text-field
                            v-model="updateProject.internal_project_title"
                            class="my-4 pa-2"
                            label="Title"
                            single-line
                            :rules="updateProject.internal_project_title != null ? max150chars : []"
                            counter>
                        </v-text-field>
                        <div class="d-flex d-block justify-end">
                            <v-btn
                                class=""
                                color="primary darken-1"
                                :disabled="updateProject.internal_project_title == undefined || updateProject.internal_project_title.length > 150"
                                @click="updateProjectTitle(updateProject)">
                                Save
                            </v-btn>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <div class="py-5 px-6 d-block header_bg_color" v-if="readyToLoad">
                <div class="info--text font-weight-bold white--text d-flex justify-space-between">
                    <div class="justify-start mr-12">
                        <router-link :to="`/user_details/${user_data.user_id}`" replace>
                            <v-btn 
                                color="white"
                                class="primary--text text--darken-3">
                                {{ user_data.full_name }}
                            </v-btn>
                        </router-link>
                    </div>
                    <div class="d-flex flex-grow-1 mt-1">
                        <div id="copy-email" class="justify-start mr-6 white--text">
                            {{ user_data.user_email }}
                            <v-tooltip 
                                v-model="trigger_copied"
                                bottom>
                                <template v-slot:activator="{ }">
                                    <v-icon small class="ml-3 mt-n1 d-inline" color="white" @click="handleCopyEmail">mdi-content-copy</v-icon>
                                </template>
                                <span>copied</span>
                            </v-tooltip>
                        </div>
                        <v-divider v-if="user_data.phone" vertical class="white mt-n1"></v-divider>
                        <div class="justify-center mx-6 white--text">{{ user_data.phone }}</div>
                        <v-divider v-if="user_data.city || user_data.state" vertical class="white mt-n1"></v-divider>
                        <div class="justify-end ml-6 white--text">{{ user_data.city }}{{ user_data.city && user_data.state ? ', ': ' ' }}{{ user_data.state }}</div>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="justify-end mt-1">
                        <v-btn 
                            icon
                            outlined
                            color="white"
                            elevation="1"
                            @click="closeProject()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </div>
            </div>
            <div class="px-5 py-5 d-flex d-block align-stretch">
                <div class="d-inline d-flex align-center pt-2 pb-1" style="width: 60%">
                    <customIcon :name="project_details.modinfo.module_key" class="d-inline ml-n2 mr-1 info--text text--lighten-2 icon-size-header" />
                    <div class="d-inline info--text text--lighten-2 label_large">
                        <div class="d-inline">
                            {{ project_details.modinfo.module_name_text }}
                            {{ project_details.project_title != null && project_details.project_title != '' ? ` :: ` : `` }}
                            <span class="font-weight-thin grey--text">{{ project_details.project_title != null && project_details.project_title != '' ? project_details.project_title : '' }}</span>
                            {{ project_details.internal_project_title != null && project_details.internal_project_title != '' ? ` :: ` : `` }}
                            <span class="font-weight-thin grey--text text--darken-2">{{ project_details.internal_project_title != null && project_details.internal_project_title != '' ? project_details.internal_project_title : '' }}</span>
                        </div>
                        <v-icon
                            small
                            color="primary darken-1"
                            class="d-inline ml-2"
                            @click.stop.prevent="openProjectTitle(project_details)">
                            mdi-pencil
                        </v-icon>
                    </div>
                </div>
                
                <div class="d-inline d-flex justify-end pt-3 pb-1" style="width: 40%">
                  <!-- @click.stop.prevent="exportResolutionData(project_details)"> -->
                    <v-btn
                        v-if="project_details.steps_completed >= 1"
                        small
                        outlined
                        color="primary darken-1"
                        class="mr-3"
                        @click.stop.prevent="exportAnswers(project_details)">
                        Export Answers
                    </v-btn>
                    <v-btn
                        small
                        elevation=0
                        color="primary darken-1"
                        @click.stop.prevent="openQuestionnaire(project_details)">
                        View Questionnaire
                    </v-btn>
                </div>
            </div>

            <v-card-text class="my-0 py-0">
                <v-card outlined class="mt-1 mb-6 py-1 px-5 d-flex d-block align-center sansation menu_bg_primary">
                    
                    <div class="d-inline">
                        <a v-if="project_detail_view != 'overview'" class="primary--text text--darken-1" @click="projectView('overview')">Overview</a>
                        <div v-if="project_detail_view == 'overview'" class="grey--text">Overview</div>
                    </div>

                    <v-divider vertical class="mx-5"></v-divider>
                    <div class="d-inline">
                        <a v-if="project_detail_view != 'activity'" class="primary--text text--darken-1" @click="projectView('activity')">Activity</a>
                        <div v-if="project_detail_view == 'activity'" class="grey--text">Activity</div>
                    </div>
                    
                    <v-divider vertical class="mx-5"></v-divider>
                    <div class="d-inline">
                        <a v-if="project_detail_view != 'docs'" class="primary--text text--darken-1" @click="projectView('docs')">Documents</a>
                        <div v-if="project_detail_view == 'docs'" class="grey--text">Documents</div>
                    </div>
                    
                    <v-divider vertical class="mx-5"></v-divider>
                    <div class="d-inline">
                        <a v-if="project_detail_view != 'users'" class="primary--text text--darken-1" @click="projectView('users')">Users</a>
                        <div v-if="project_detail_view == 'users'" class="grey--text">Users</div>
                    </div>

                    <v-divider v-if="project_details.modinfo.module_key === 'entity-maintenance-program'" vertical class="mx-5"></v-divider>
                    <div class="d-inline" v-if="project_details.modinfo.module_key === 'entity-maintenance-program'">
                        <a v-if="project_detail_view != 'resolutions'" class="primary--text text--darken-1" @click="projectView('resolutions')">Resolutions</a>
                        <div v-if="project_detail_view == 'resolutions'" class="grey--text">Resolutions</div>
                    </div>

                    <v-divider v-if="project_details.show_psr" vertical class="mx-5"></v-divider>
                    <div class="d-inline" v-if="project_details.show_psr">
                        <a v-if="project_detail_view != 'report'" class="primary--text text--darken-1" @click="projectView('report')">PSR</a>
                        <div v-if="project_detail_view == 'report'" class="grey--text">PSR</div>
                    </div>

                </v-card>

                <v-card v-if="project_detail_view == 'overview'" elevation="0" class="px-5 pb-12">
                    <ProjectData
                        :projectDetails="project_details"
                        :project_calls="project_details.modinfo.calls_allowed"
                        :revision_opportunities="project_details.modinfo.revision_rounds"
                        :showCompletedDate="showCompletedDate"
                        :entity_filing_status_list="entity_filing_status_list"
                        @estCompletionDate="estCompletionDate"
                        @pullActivityLogs="pullActivityLogs"
                        @saveProject="saveProject"
                        @holdProjectStatus="holdProjectStatus"
                        @refreshUsers="refreshUsers" />
                </v-card>

                <v-card v-if="project_detail_view == 'activity'" elevation="0" class="px-5 pb-12">
                    <ActivityLogs
                        :projectDetails="project_details"
                        @deleteLog="deleteLog"
                        @logManualNote="logManualNote" />
                </v-card>

                <v-card v-if="project_detail_view == 'report' && project_details.show_psr" elevation="0" class="px-5 pb-12">
                    <ProjectReport
                        :projectDetails="project_details"
                    />
                </v-card>

                <v-card v-if="project_detail_view == 'docs'" elevation="0" class="px-5 pb-12">
                    <ProjectFiles
                        :projectDetails="project_details"
                        :refresh_docs="refresh_docs"
                        @pullProjectDocs="pullProjectDocs" />

                    <div class="my-10">&nbsp;</div>
                    
                    <ProjectDeliverables
                        :projectDeliverables="project_details"
                        :refresh_delivs="refresh_delivs"
                        @pullProjectDelivs="pullProjectDelivs"
                        @openDeliverableDialog="openDeliverableDialog" />
                </v-card>

                <v-card v-if="project_detail_view == 'users'" elevation="0" class="px-5 pb-12">
                    <ProjectUsers
                        :projectDetails="project_details"
                        @refreshUsers="refreshUsers" />
                </v-card>
                <v-card v-if="project_detail_view == 'resolutions' && project_details.modinfo.module_key === 'entity-maintenance-program'" elevation="0" class="px-5 pb-12">
                    <ProjectResolutions
                        :projectDetails="project_details"
                    />
                </v-card>

              </v-card-text>
            <v-card-actions class="pa-4 d-flex" style="border-top: 1px solid #BDBDBD">
                <v-btn 
                    class="d-inline menu_bg_primary primary--text text--darken-1"
                    elevation=0
                    @click="initDisableProject(project_details)">
                    <v-icon color="primary darken-1" class="mr-3" left> {{ project_details.is_archived ? 'mdi-archive-off' : project_details.has_data ? 'mdi-archive' : 'mdi-delete' }}</v-icon>
                    {{ project_details.is_archived ? 'Unarchive this Project' : project_details.has_data ? 'Archive this Project' : 'Delete this Project' }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn 
                    class="d-inline menu_bg_primary primary--text text--darken-1"
                    elevation=0
                    :loading="refreshing_project"
                    @click="refreshProject(project_details)">
                    <v-icon color="primary darken-1">mdi-refresh</v-icon>
                </v-btn>
            </v-card-actions>
        </div>
    </div>
</template>


<script>  
    import axios from "axios";
    import Cookie from 'js-cookie';
    import appUrls from '../helpers/environment';
    // import { prepProjectData } from '../components/shared/projectFunctions';

    // import ProjectData from './ProjectData'
    // import ProjectFiles from './ProjectFiles';
    // import ProjectDeliverables from './ProjectDeliverables';
    // import ModuleQuestionnaire from './ModuleQuestionnaire'
    // import UploadDeliverables from './UploadDeliverables'
    // import ActivityLogs from './ActivityLogs'
    // import ProjectUsers from './ProjectUsers'
    // import ProjectReport from './ProjectReport'
    // import ProjectResolutions from './ProjectResolutions.vue'
    // import { ExportToCsv } from 'export-to-csv';

    export default {
        name: 'ProjectDetails',

        components: {
            // ProjectData,
            // ProjectFiles,
            // UploadDeliverables,
            // ProjectDeliverables,
            // ModuleQuestionnaire,
            // ActivityLogs,
            // ProjectUsers,
            // ProjectReport,
            // ProjectResolutions
        },

        props: {
            user_id: String,
            project_id: String,
            closeDetailDialog: Function
        },

        data () {
            return {
                notify_user: false,
                notify_user_duration: 6000,
                notify_user_color: 'success',
                notify_user_text_color: 'info--text',
                notify_user_message: '',
                trigger_copied: false,
                project_details: {},
                user_data: {},
                date_menu: false,
                disableDialog: false,
                profileDialog: false,
                deliverableDialog: false,
                titleDialog: false,
                dateMenu: false,
                archive_action: '',
                remove_project_id: '',
                remove_module_name: '',
                refresh_docs: false,
                refresh_delivs: false,
                refreshing_project: false,
                triggerFeedback: false,
                project_detail_view: 'overview',
                noteArgs: {},
                available_buyer_listings: [],
                expressData: {},
                holdArgs: {},
                stepArgs: {},
                statusArgs: {},
                disableArgs: {},
                buyerProject: [],
                entity_filing_status_list: [],
                moduleKey: '',
                moduleId: '',
                projectId: '',
                show_this: '',
                projectDeliverables: [],
                max150chars: [v => v.length <= 150 || 'Max 150 characters'],
                updateProject: {},
                showCompletedDate: false,
                readyToLoad: false
            }
        },

        watch: {            
            project_id: {
                handler(val){
                    if (val) {
                        this.projectDetails(this.user_id, this.project_id);
                    }
                }
            }
        },

        mounted () {
            this.projectDetails(this.user_id, this.project_id);
        },
        
        methods: {
            closeProject: function () {
                this.readyToLoad = false
                this.project_detail_view = 'overview'
                this.$emit('closeDetailDialog', false)
            },
            // formatDate: function ( date, mask ) {
            //     if ( date == null ) {
            //         if ( this.projectDetails.module_class == 1 ) {
            //             const day_type = this.projectDetails.module_key == 'valuation-starter' ? 'calendar' : 'business'
            //             return `7 ${day_type} days after Questionnaire`
            //         } else {
            //             return `Calculated after Questionnaire`
            //         }
            //     }
            //     return dateFormat(date.substr(0,10)+' 00:00:00', mask)
            // },

            // formatDate (date, digits_of_year=4) {
            //     if (!date) return null;

            //     const [year, month, day] = date.split('-');
            //     return `${month}/${day}/${digits_of_year == 2 ? year.substr(2,2) : year}`;
            // },
            
            projectView: async function (view) {
                this.project_detail_view = view
            },

            triggerUserFeedback: function ( feedback_trigger, feedback_message, feedback_color='success' ) {
                this.notify_user = feedback_trigger;
                this.notify_user_color_scheme = `${feedback_color} ${this.notify_user_text_color}`
                this.notify_user_message = feedback_message;
            },

            openQuestionnaire: function ( prj ) {
                this.moduleKey = prj.modinfo.module_key
                this.projectId = prj.project_id
                this.moduleId = prj.module_id

                setTimeout(()=>{ 
                    this.profileDialog = true 
                }, 1000)
            },

            projectDetails: async function ( userId , projectId ) {
                try {
                    await this.getLists();
                    const current_project = await axios.get(`${appUrls.api}/api/admin/current_project/${userId}/${projectId}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })
                    
                    if ( current_project.data.outcome ) {
                        this.project_details = current_project.data.project_data;
                        await this.getUserData(this.project_details.user_id)
                     } else {
                        this.notify_user = true;
                        this.notify_user_message = current_project.data.message;
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            getUserData: async function ( uid ) {
                try {
                    const user_data = await axios.get(`${appUrls.api}/api/admin/user_details/${uid}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    if ( user_data.data.outcome ) {
                        this.user_data = user_data.data.user[0]
                        this.user_data.full_name = this.user_data.first_name+' '+this.user_data.last_name
                        this.readyToLoad = true
                    }
                } catch ( error ) {
                    console.log(error);
                    this.triggerUserFeedback( true, error );
                }
            },

            openDeliverableDialog: function ( data ) {
                this.deliverableDialog = true
                this.projectDeliverables = data
                this.moduleKey = data.modinfo.module_key
                this.projectId = data.project_id
            },

            closeUploadDeliverables: function () {
                this.deliverableDialog = false
            },

            openProjectTitle: function ( prj ) {
                this.titleDialog = true
                this.updateProject = prj
            },

            updateECD: function ( data ) {
                this.estCompletionDate( data.user_id, data.project_id, data.close_date);
                setTimeout(() => { this.pullActivityLogs(data) }, 500)
            },
            
            takeNote: async function () {
                this.$emit('saveNotes', this.noteArgs);
            },

            logManualNote: async function (project, manual_note, note_type) {
                try {
                    if ( manual_note ) {
                        const manual_log_rs = await axios.post(`${appUrls.api}/api/admin/log_notes`, {
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                            manual_note: manual_note,
                            note_type: note_type,
                            project: project
                        })

                        setTimeout(() => {
                            this.project_details.activity = manual_log_rs.data.logs
                        }, 800)

                    } else {
                        this.triggerUserFeedback( true, "Please fill in the field to make a note!" );
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            deleteLog: async function ( project, log_id ) {
                try {
                    const manual_log_rs = await axios.post(`${appUrls.api}/api/admin/delete_log`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        log_id: log_id
                    })

                    this.pullActivityLogs(project)
                    
                } catch ( error ) {
                    console.log(error);
                }
            },

            expediteProject: async function ( project ) {
                try {
                    const expedite_project_rs = await axios.put(`${appUrls.api}/api/admin/project_expedite`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        project
                    })

                    if( expedite_project_rs.data.outcome ){
                        // this.updateProject = {}
                        this.triggerUserFeedback( true, expedite_project_rs.data.message );
                        this.pullActivityLogs(project)
                    } else {
                        this.triggerUserFeedback( true, expedite_project_rs.data.message );
                        this.pullActivityLogs(project)
                    }

                } catch ( error ) {
                    console.log(error);
                }
            },

            updateProjectTitle: async function ( project ) {
                try {
                    const add_project_title_rs = await axios.put(`${appUrls.api}/api/admin/internal_project_title`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        project
                    })

                    if( add_project_title_rs.data.outcome ){
                        this.titleDialog = false
                        // this.updateProject = {}
                        this.triggerUserFeedback( true, add_project_title_rs.data.message );
                    } else {
                        this.triggerUserFeedback( true, add_project_title_rs.data.message );
                    }

                } catch ( error ) {
                    console.log(error);
                }
            },

            getLists: function () {
                let optionsLists = [ 
                    {'name': 'entity_filing_status', 'type': 'txt'}
                ];

                axios.post(`${appUrls.api}/api/lists`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    list_options: optionsLists
                })
                .then( res => {
                    if(res.data.outcome){
                        this.arrLists = res.data.lists;                        
                        // SET PROPERTIES WITH THIER APPROPRIATE LIST
                        for (let l in this.arrLists) {
                            if (this.arrLists[l].name == 'entity_filing_status') this.entity_filing_status_list = this.arrLists[l].list
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            pullActivityLogs: async function ( project_details ) {
                try {
                    if ( typeof project_details != 'object' ) {
                        project_details = this.projects.find(p => p.project_id == project_details)
                    }

                    const logs_rs = await axios.post(`${appUrls.api}/api/admin/pull_activity`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        project: project_details
                    })

                    if ( logs_rs ) {
                        this.project_details.activity = logs_rs.data.activity
                        return true
                    }
                
                } catch ( error ) {
                    console.log(error);
                    return false
                }
            },

            saveProject: async function ( stepArgs ) {
                stepArgs.prj.steps_completed = stepArgs.step.is_independent ?
                    stepArgs.prj.steps_completed :
                    stepArgs.step.completed_val ? (stepArgs.prj.steps_completed + 1) : (stepArgs.prj.steps_completed - 1);

                stepArgs.prj.complete = Math.round(((stepArgs.prj.steps_completed / stepArgs.prj.modinfo.steps_to_complete) * 100)) > 100 ? 100 : Math.round(((stepArgs.prj.steps_completed / stepArgs.prj.modinfo.steps_to_complete) * 100));

                if ( stepArgs.prj.complete == 100 ) {
                    stepArgs.prj.status_text  = 'Complete';
                    stepArgs.prj.status_color = 'primary--text text--darken-1';
                    stepArgs.prj.status_progress_color = 'primary';
                    
                    stepArgs.prj.status = 'complete'
                    const this_newDate = new Date()
                    stepArgs.prj.close_date = String(String(this_newDate.getFullYear()).concat('-',this_newDate.getMonth()+1).padStart(2, '0').concat('-', String(this_newDate.getDate()).padStart(2, '0')))
                    this.showCompletedDate = true
                } else if ( stepArgs.prj.complete < 100 ) {
                    switch ( stepArgs.prj.steps_completed ) {
                        case 0: stepArgs.prj.status_text = 'Open'; break;
                        case 1: stepArgs.prj.status_text = 'Review'; break;
                        default: stepArgs.prj.status_text = 'Processing'; break;
                    }
                    stepArgs.prj.status_color = 'success--text text--darken-2';
                    stepArgs.prj.status_progress_color = 'success darken-1';
                    this.showCompletedDate = false
                }

                const project_saved = await this.saveProjectProgress( stepArgs )
                if ( project_saved ) {
                    const pullActivity = await this.pullActivityLogs(stepArgs.prj)
                    if ( pullActivity ) this.projectDetails(stepArgs.prj.project_id, stepArgs.prj.project.user_id);
                }
            },

            holdProject: async function ( holdArgs ) {
                holdArgs.project_details.status = holdArgs.step.on_hold ? 'hold' : 'open'
                holdArgs.project_details.status_text = holdArgs.step.on_hold ? 'Hold' : 'Open'
                holdArgs.project_details.status_color = holdArgs.step.on_hold ? 'deep-orange--text text--darken-1' : 'success--text text--darken-2'
                holdArgs.project_details.status_progress_color = holdArgs.step.on_hold ? 'deep-orange darken-1' : 'success darken-1'

                this.holdProjectStatus( holdArgs.project_details )
                setTimeout(() => { this.pullActivityLogs(holdArgs.project_details) }, 500)
            },

            initDisableProject: async function ( prj ) {
                this.disableDialog = true;            
                const archive_action = prj.is_archived ? 'unarchive' : prj.has_data ? 'archive' : 'remove';
                const project_status = archive_action == 'archive' && prj.steps_completed >= prj.modinfo.steps_to_complete ? 'complete' : 'closed'
                
                this.disableArgs = { 
                    remove_project_id: prj.project_id, 
                    remove_module_name: prj.module_name_text, 
                    archive_action: archive_action,
                    project_status: project_status
                }
            },

            disableArchive: async function () {
                this.disableProject( this.disableArgs );
            },

            disableProject: async function ( data ) {
                const projectId = data.remove_project_id
                const moduleName = data.remove_module_name
                const projectAction = data.archive_action
                const projectStatus = data.project_status
                this.disableDialog = false;

                const disable_project = await axios.post(`${appUrls.api}/api/admin/disable_project`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    data: {
                        action: projectAction,
                        project_id: projectId,
                        module_name: moduleName,
                        project_status: projectStatus
                    }
                })

                if( disable_project ) {
                    if(disable_project.data.outcome){
                        this.notify_user = true;
                        this.notify_user_message = disable_project.data.message;
                    }
                } else {
                    (error) => { console.log(error) }
                }
            },

            refreshProject: async function ( prj ) {
                try {
                    this.refreshing_project = true;
                    const prj_rs = await axios.get(`${appUrls.api}/api/admin/current_project/${prj.user_id}/${prj.project_id}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    })

                    setTimeout(() => {
                        this.project_details = prj_rs.data.project_data                        
                        this.refreshing_project = false;

                        if ( this.project_details.status == 'complete' ) {
                            this.showCompletedDate = true
                        } else {
                            this.showCompletedDate = false
                        }
                    }, 1000)
                    setTimeout(() => {
                        this.triggerUserFeedback( true, "Project data has been refreshed");
                    }, 2000)
                
                } catch ( error ) {
                    console.log(error);
                }
            },

            exportAnswers: function ( project_details ) {
                axios.post(`${appUrls.api}/api/admin/export_data`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    moduleKey: project_details.modinfo.module_key,
                    projectId: project_details.project_id,
                    userId: project_details.user_id,
                    parentProjectId: project_details.parent_project_id
                })
                .then( res => {
                    if( res.data.outcome ){
                        this.notify_user = true;
                        this.notify_user_message = res.data.message;

                        const this_fileData = new Buffer(res.data.buf, 'base64');
                        const this_fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                        const this_fileName = res.data.basic_data.file_name+'.'+res.data.basic_data.output_type;
                        
                        const this_blob = new Blob([this_fileData], {type: this_fileType});
                        saveAs(this_blob, this_fileName);

                    } else {
                        this.notify_user = true;
                        this.notify_user_color = 'accent';
                        this.notify_user_message = 'There was a problem during the process of exporting the answers for this project.';
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            pullProjectDocs: async function ( project_details ) {
                try {
                    this.refresh_docs = true
                    const pulled_files = await axios.post(`${appUrls.api}/api/pull_files/${project_details.project_id}/false`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    setTimeout(() => {
                        project_details.docs = pulled_files.data.files.filter( file => file.is_revision == false);
                        project_details.revs = pulled_files.data.files.filter( file => file.is_revision == true);
                        this.refresh_docs = false
                    }, 2000)
                
                } catch ( error ) {
                    console.log(error);
                }
            },

            pullProjectDelivs: async function ( project_details ) {
                try {
                    this.refresh_delivs = true
                    const pulled_files = await axios.post(`${appUrls.api}/api/pull_files/${project_details.project_id}/true`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    setTimeout(() => {
                        project_details.dlvs = pulled_files.data.files;
                        this.refresh_delivs = false
                        this.refreshProject(project_details)
                    }, 2000)
                
                } catch ( error ) {
                    console.log(error);
                }
            },

            refreshUsers: async function ( parentUserId, projectId, message_override='' ) {
                try {
                    const project_users = await axios.get(`${appUrls.api}/api/project_users/${parentUserId}/${projectId}/false`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })
                
                    this.project_details.users = project_users.data.users
                    this.project_details.admins = project_users.data.admins

                    const feedback_msg = message_override != '' ? message_override : project_users.data.message
                    this.triggerUserFeedback( true, feedback_msg);
                    this.pullActivityLogs(this.project_details)
                
                } catch ( error ) {
                    console.log(error);
                    triggerUserFeedback( true, error );
                }
            },

            saveProjectProgress: async function ( data ) {
                // FILTER ONLY RELEVANT DATA
                const [project_data, process_data] = prepProjectData( data )
                // console.log('update project', project_data, process_data);
                // return false;
                axios.post(`${appUrls.api}/api/admin/update_current_project`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    project: project_data,
                    progress: process_data
                })
                .then( res => {
                    if(res.data.outcome){
                        this.notify_user = true;
                        this.notify_user_message = res.data.message;

                        return true
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    return false
                });
            },

            holdProjectStatus: async function ( data ) {
                const project_data = data.project_details
                const step_data = data.step

                axios.put(`${appUrls.api}/api/admin/project_hold`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    project: project_data,
                    step: step_data
                })
                .then( res => {
                    if(res.data.outcome){  
                        this.notify_user = true;
                        this.notify_user_message = res.data.message;

                        setTimeout(() => {
                            this.projectDetails();
                        }, 2000)
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            estCompletionDate: async function ( uid, pid, date ) {
                axios.put(`${appUrls.api}/api/admin/project_ecd`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    user_id: uid,
                    project_id: pid,
                    ecd: date
                })
                .then( res => {
                    if(res.data.outcome){                        
                        this.triggerUserFeedback( true, res.data.message);

                        setTimeout(() => {
                            this.projectDetails();
                        }, 2000)
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            handleCopyEmail: function () {
                navigator.clipboard.writeText(document.querySelector('div#copy-email').innerText)
                this.trigger_copied = true;
                setTimeout(() => { this.trigger_copied = false; }, 3000);
            },

            gatherInitialQuestionnaire: async function (parentProjId) {
              const dataObj = {}
                const res = await axios.get(`${appUrls.api}/api/user_data/${parentProjId}`, {
                  headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                })

                for (const { section, question, value_type, answer, date_saved } of res.data.values) {
                  const key = `${section}_${question}`
                  // this.last_saved = new Date(date_saved).toLocaleString('en-US')

                  if (value_type === 'object' && answer != '') {
                    dataObj[key] = JSON.parse(answer)
                  } else {
                    dataObj[key] = answer
                  }
                }
                return dataObj
            },

            gatherResolutionData: async function (projId) {
                const dataObj = {}
                const res = await axios.get(`${appUrls.api}/api/user_data/${projId}`, {
                  headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                })

                for (const { section, question, value_type, answer, date_saved } of res.data.values) {
                  const key = `${section}_${question}`

                  if (value_type === 'object' && answer != '') {
                    dataObj[key] = JSON.parse(answer)
                  } else {
                    dataObj[key] = answer
                  }
                }

                return dataObj
            },

            // generateResolutionPdf: async function (project_details) {
            //     const resolutionData = await this.gatherResolutionData(project_details.project_id)
            //     const questionnaireData = await this.gatherInitialQuestionnaire(project_details.parent_project_id)
            //     const res = await axios.post(`${appUrls.api}/api/resolution_export`, {
            //       headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
            //       data: {
            //         resolutionData,
            //         questionnaireData
            //       }
            //     })
            //     .then( res => {
            //         if(res.data.outcome){  
            //           console.log("res", res)
            //         }
            //     })
            //     .catch(function (error) {
            //         console.log(error);
            //     });

            // }
            exportResolutionData: async function (project_details) {
              const resolutionData = await this.gatherResolutionData(project_details.project_id)
              const questionnaireData = await this.gatherInitialQuestionnaire(project_details.parent_project_id)
              return await axios.post(`${appUrls.api}/api/admin/resolution_export`, {
                headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                data: {
                  resolutionData,
                  questionnaireData
                }
              })
              .then(res => {
                // console.log(res.data)
                  const options = {
                    fieldSeparator: ',',
                    quoteStrings: '"',
                    decimalSeparator: '.',
                    useTextFile: false,
                    useBom: true,
                    useKeysAsHeaders: true,
                  };

                  const csvExporter = new ExportToCsv(options);

                  csvExporter.generateCsv(res.data.csvExport);
              })
              .catch(function (error) {
                console.log(error);
              });
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .bg_pewter {
        background-color: #E9EAEC !important;
    }
    .menu_bg_primary {
        background-color: #eef7f8 !important;
    }
    .header_bg_color {
        font-size: 1.15em !important;
        background-color: var(--v-primary-darken3)
    }
    .icon-size {
        width: 3rem;
    }
    .icon-size-small {
        width: 2.25rem;
    }
    .icon-size-header {
        width: 3rem;
    }
    .icon-center {
        margin: 0 auto;
    }
    .refresh_response {
        font-size: .8rem;
    }
    .click_indicator {
		width: 50px; 
		height: 3px; 
		border-top: 1px dotted rgba(0,0,0,.3);
		border-bottom: 1px dotted rgba(0,0,0,.3);
	}
    .user_link {
        text-decoration: none;
    }
    .user_link:hover {
        text-decoration: underline;
    }
    .center_snackbar_message {
        width: 100%; 
        margin:0 auto; 
        text-align: center;
        font-size: 1rem;
        font-weight: bold;
        font-family: 'AvenirMedium';
    }
</style>


// WEBPACK FOOTER //
// src/components/ProjectDetails.vue